import type { StaffDashboardVariant } from '../features/auth/portal-access';
import { STAFF_DASHBOARD_VARIANT_LABELS } from '../features/auth/portal-access';
import { cx } from '../lib/class-names';

import styles from './PortalComponents.module.css';

export function DashboardVariantTabs({
  variants,
  active,
  onChange,
}: {
  variants: readonly StaffDashboardVariant[];
  active: StaffDashboardVariant;
  onChange: (variant: StaffDashboardVariant) => void;
}): React.JSX.Element | null {
  if (variants.length <= 1) {
    return null;
  }

  return (
    <div className={styles.tabList} role="tablist" aria-label="Dashboard view">
      {variants.map((variant) => (
        <button
          key={variant}
          type="button"
          role="tab"
          aria-selected={active === variant}
          className={cx(styles.tabButton, active === variant && styles.tabButtonActive)}
          onClick={() => {
            onChange(variant);
          }}
        >
          {STAFF_DASHBOARD_VARIANT_LABELS[variant]}
        </button>
      ))}
    </div>
  );
}
